module.exports = __webpack_public_path__ + "img/th.9a68976f.png";